/**
 * Feature plan access map
 * `null` = free for all, "standard" = std/gold, "gold" = gold only
 */
export const featurePlanMap = {
  myassets: null,
  styleuai: "trial",  // ✅ allows trial users
  seocontent: "gold",
  bgremover: null,
  enhancer: "standard",
  bggenerator: "gold",
  influencer: "gold",
  outputs: null,
  designRequest: "gold",
  videogenerator: "gold"
};

export const canAccessFeature = (user, featureId) => {
  const required = featurePlanMap[featureId];
  if (!required) return true;

  const plan = user?.activePlan;

  if (required === "trial") {
    return ["trial", "standard", "gold"].includes(plan); // ✅ this must include "trial"
  }

  if (required === "standard") {
    return ["standard", "gold"].includes(plan);

  } else if (required === "gold") {
    return plan === "gold";
  }

  return false;
};


/**
 * Utility: user on standard or gold
 */
export const canUseStandardFeature = (user) => {
  return ["standard", "gold"].includes(user?.activePlan);
};

/**
 * Utility: user on gold
 */
export const canUseGoldFeature = (user) => {
  return user?.activePlan === "gold";
};

/**
 * Utility: has credits
 */
export const hasCredits = (user) => {
  return typeof user?.credits === "number" && user.credits > 0;
};

/**
 * Utility: can send design request
 */
export const canSendDesignRequest = (user) => {
  return user?.activePlan === "gold" && user?.designRequestsLeft > 0;
};

/**
 * Utility: is free user
 */
export const isFreeUser = (user) => {
  return !user?.activePlan || user?.activePlan === "free";
};
